import React from "react";
import { Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NuevoIMG from "./assets/img/nuevo2.jpg";
import "./assets/nuevo.css";

function Nuevo() {
  const navigate = useNavigate();

  const handleLocationClick = () => {
    navigate("/soy-nuevo");
  };

  return (
    <section className="page-section nuevo-section">
      <div className="container">
        <div className="nuevo-grid">
          {/* Title Box */}
          <div className="nuevo-title-box">
            <Typography variant="h3" style={{ fontWeight: "bold", marginBottom: "1rem", lineHeight: 1.2 }}>
              ¿Eres nuevo?
            </Typography>
            <Typography variant="body1" style={{ lineHeight: 1.6, maxWidth: "300px" }}>
              Te damos la bienvenida a nuestra comunidad de fe. Descubre cómo puedes ser parte de nuestra familia.
            </Typography>
          </div>

          {/* Button Box */}
          <div className="nuevo-button-box">
            <Typography variant="h5" style={{ color: "white", fontWeight: "bold", marginBottom: "1rem", textAlign: "center" }}>
              ¡Únete a nosotros!
            </Typography>
            <Button
              variant="contained"
              size="large"
              onClick={handleLocationClick}
              style={{
                background: "white",
                color: "var(--primary-color)",
                fontWeight: "bold",
                padding: "12px 32px",
                borderRadius: "8px",
                textTransform: "none",
                fontSize: "1.1rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              }}
            >
              Conoce más
            </Button>
          </div>

          {/* Image Box */}
          <div className="nuevo-image-box">
            <img src={NuevoIMG} alt="Nuevo en la iglesia" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Nuevo;
